import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import Tooltipable from "~/components/effects/tooltipable";
import { PIN_LIMIT } from "~/helpers/pinHelpers";

const PinButton = ({
  isPinned = false,
  isAtLimit = false,
  pinnedCount = 0,
  onToggle,
  canPin = true,
  canUnpin = true,
  isLoading = false,
}) => {
  if (!canPin) {
    return null;
  }

  // Pinned but user cannot unpin (agent viewing another's pinned activity)
  if (isPinned && !canUnpin) {
    return (
      <span className="btn btn-secondary btn-sm mr5 pin-button-disabled">
        <FontAwesomeIcon icon={["fas", "fa-thumbtack"]} />
      </span>
    );
  }

  let tooltipText;
  if (isPinned) {
    tooltipText = "Unpin";
  } else if (isAtLimit) {
    tooltipText = `Unpin an activity first (${pinnedCount}/${PIN_LIMIT} pinned)`;
  } else {
    tooltipText = "Pin to top";
  }

  const icon = isPinned ? ["fas", "fa-thumbtack"] : ["far", "fa-thumbtack"];

  return (
    <Tooltipable text={tooltipText}>
      <button
        type="button"
        className="btn btn-secondary btn-sm mr5"
        onClick={onToggle}
        disabled={isLoading}
      >
        <FontAwesomeIcon icon={icon} />
      </button>
    </Tooltipable>
  );
};

export default PinButton;
